<script setup lang="ts">
import { useTranslation } from 'i18next-vue';

import { CheckAllIcon, UiButton } from '@peanuds/ui';

interface Props {
  disabled: boolean;
}

defineProps<Props>();
defineEmits<{ markAllAsRead: [] }>();

const { t } = useTranslation();
</script>

<template>
  <div class="notifications-drawer-footer">
    <UiButton
      :label="t('nav.notifications_actions.mark_all_as_read')"
      severity="secondary"
      iconPos="right"
      :disabled="disabled"
      @click="$emit('markAllAsRead')"
    >
      <template #icon>
        <CheckAllIcon class="notifications-drawer-footer__icon" />
      </template>
    </UiButton>
  </div>
</template>

<style scoped lang="scss">
.notifications-drawer-footer {
  display: flex;
  justify-content: flex-end;
  padding: $spacing-lg $spacing-xl;
  background: $color-bg-elevated;
  border-top: 1px solid $color-border-idle;
}

.notifications-drawer-footer__icon {
  width: $icon-size-sm;
  height: $icon-size-sm;
}
</style>
